import { isEmpty } from 'lodash';
import { memo, useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import trans from 'translation';
import { KContainer, KLabel, KLoading } from 'uikit';
import { v4 as uuidv4 } from 'uuid';
interface IProps {
  name: string;
  data: any[];
  isLoading: boolean;
  hasNextPage: boolean;
  onEndReached: () => void;
  renderRow: (item: any) => JSX.Element;
}

const InfiniteScrollWrapper = ({
  name,
  data,
  isLoading,
  hasNextPage,
  onEndReached,
  renderRow
}: IProps) => {
  const _name = useMemo(() => {
    const id = uuidv4();
    return `${name}-${id}`;
  }, [name]);
  return (
    <KContainer.View id={_name} dp="flex" flex>
      <InfiniteScroll
        height={'100vh'}
        dataLength={data.length}
        next={onEndReached}
        hasMore={hasNextPage as any}
        loader={isLoading ? <KLoading /> : null}
        scrollableTarget={_name}
        scrollThreshold={0.5}
        style={{
          flex: 1,
          paddingBlock: '0.25rem'
        }}
      >
        {!isEmpty(data) ? (
          data.map(i => renderRow(i))
        ) : (
          <KContainer.View
            dp="flex"
            row
            justifyContent="center"
            height={'100%'}
            alignItems="center"
          >
            <KLabel.Text typo="TextNmNormal">
              {trans('no_data_found')}
            </KLabel.Text>
          </KContainer.View>
        )}
      </InfiniteScroll>
    </KContainer.View>
  );
};

export default memo(InfiniteScrollWrapper);
